module.exports = __webpack_public_path__ + "static/x86.bde15366.png";